<template>
  <div class="d-flex flex-column justify-content-center align-items-center h-100 text-secondary">
    <span>
      <component :is="icon"></component>
    </span>

    <h3 v-if="header">{{ header }}</h3>
    <p v-if="content">{{ content }}</p>
  </div>
</template>

<script>
  export default {
    props: {
      icon: {
        type: String,
        default: 'b-icon-bricks'
      },

      header: {
        type: String
      },

      content: {
        type: String
      }
    }
  }
</script>

<style scoped>
  span {
    font-size: 5rem;
  }
</style>